import { motion } from 'framer-motion';
import ButtonLink from '@components/common/Button/ButtonLink';
import { usePageSetup } from '@/hooks/usePageSetup';

export const PrivacyPolicyPage = () => {
  usePageSetup('Privatumo politika - Finhudas', { scroll: true })

  return (
    <div className="h-full bg-white p-5 pt-8 pb-8 flex flex-col">
      <div className="flex-1 overflow-y-auto">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="text-2xl font-bold mb-4 text-center"
        >
          PRIVATUMO POLITIKA
        </motion.h1>
        <div className="space-y-4 text-base text-gray-800">
          <p>Ši Privatumo politika (toliau – „Politika“) apibrėžia, kaip MB Kurohudas (įmonės kodas 306705828, Vytauto g. 34-5, LT-92127 Klaipėda, Lietuva) (toliau – „Mes“, „Paslaugų teikėjas“ arba „Valdytojas“) tvarko Jūsų asmens duomenis, kai naudojatės mūsų mobiliąja ir internetine programėle „Finhudas“ (toliau – „Paslauga“), kuri skirta individualią veiklą vykdantiems pavežėjams. Naudojantis Paslauga, Jūs sutinkate su šioje politikoje pateiktais duomenų tvarkymo principais.</p>
          <h2 className="text-lg font-semibold mt-6">1. DUOMENŲ TVARKYMO VALDYTOJAS</h2>
          <p>1.1. Asmens duomenų valdytojas, atsakingas už Jūsų asmens duomenų tvarkymą, yra MB Kurohudas, įmonės kodas 306705828, registruota Vytauto g. 34-5, LT-92127 Klaipėda, Lietuva, el. paštas: <a href="mailto:info@finhudas.lt" className="text-blue-600 underline">info@finhudas.lt</a>.</p>
          <p>1.2. Jei turite klausimų apie savo asmens duomenų tvarkymą, prašome susisiekti su mumis aukščiau nurodytu el. paštu.</p>
          <h2 className="text-lg font-semibold mt-6">2. RENKAMI ASMENS DUOMENYS</h2>
          <p>2.1. Mes galime rinkti ir apdoroti šiuos Jūsų asmens duomenis:</p>
          <ul className="list-disc ml-6">
            <li><b>a) Kontaktiniai duomenys:</b>
              <ul className="list-disc ml-6">
                <li>Vardas, pavardė;</li>
                <li>Asmens kodas;</li>
                <li>El. paštas;</li>
                <li>Telefono numeris;</li>
                <li>Reg. gyvenamosios vietos adresas;</li>
                <li>Individualios veiklos numeris;</li>
              </ul>
            </li>
            <li><b>b) Vairuotojo duomenys:</b>
              <ul className="list-disc ml-6">
                <li>Vairuotojo ar transporto priemonės registracijos duomenys;</li>
                <li>Pajamas ir veiklos sąnaudas pagrindžiantys dokumentai;</li>
              </ul>
            </li>
            <li><b>c) Programos naudojimo ir įrenginio duomenys:</b>
              <ul className="list-disc ml-6">
                <li>IP adresas;</li>
                <li>Naršyklės tipas ir versija;</li>
                <li>Mobiliojo įrenginio informacija (modelis, operacinė sistema);</li>
                <li>Naudojimosi Paslauga statistika (pvz., prisijungimo laikas, funkcionalumo naudojimas);</li>
              </ul>
            </li>
          </ul>
          <p>2.2. Duomenys renkami tik tiek, kiek jie yra būtini Paslaugos tikslams pasiekti ir teisėtiems interesams.</p>
          <h2 className="text-lg font-semibold mt-6">3. ASMENS DUOMENŲ TVARKYMO TIKSLAI IR TEISINIAI PAGRINDAI</h2>
          <p>3.1. Jūsų asmens duomenys gali būti tvarkomi šiais tikslais:</p>
          <ul className="list-disc ml-6">
            <li>Paslaugos teikimas – Jūsų duomenys reikalingi Paslaugos funkcionalumui užtikrinti, įskaitant veiklos sąnaudų sekimą, rekomendacijas. Paslauga nėra mokesčių konsultavimo ar apskaitos paslauga. Naudojimosi Paslauga metu pateikta informacija yra tik rekomendacinio pobūdžio.</li>
            <li>Paskyros administravimas – Siekiame administruoti Jūsų paskyrą, kurioje pateikiama informacija apie uždarbį, sąnaudas bei mokesčius.</li>
            <li>Paslaugos gerinimas ir analizė – Jūsų duomenys gali būti naudojami tobulinant Paslaugos kokybę, analizuojant naudojimosi tendencijas.</li>
            <li>Teisiniai įsipareigojimai – Apdorojame duomenis, kad atitiktume galiojančius teisės aktus.</li>
          </ul>
          <p>3.2. Duomenų tvarkymo pagrindai:</p>
          <ul className="list-disc ml-6">
            <li>Sutarties vykdymas – Duomenys apdorojami pagal sutartinius įsipareigojimus, siekiant užtikrinti Paslaugos teikimą.</li>
            <li>Jūsų sutikimas – Jei reikalaujama, mes prašome Jūsų sutikimo apdoroti asmens duomenis.</li>
            <li>Teisiniai įsipareigojimai – Kai apdorojimas būtinas teisiniais tikslais (pvz., mokesčių ataskaitos).</li>
            <li>Legitimus interesas – Kai apdorojimas pagrįstas mūsų teisėtu interesu užtikrinti Paslaugos saugumą ir tobulinimą.</li>
          </ul>
          <h2 className="text-lg font-semibold mt-6">4. ASMENS DUOMENŲ SAUGOJIMAS</h2>
          <ul className="list-disc ml-6">
            <li>Jūsų asmens duomenys bus saugomi tiek, kiek tai būtina Paslaugos tikslams pasiekti ir teisėtai apdorojimo trukmei.</li>
            <li>Asmens duomenys, kurie nėra būtini teikti Paslaugą, bus ištrinti arba anonimizuoti, kai jie taps nebereikalingi Paslaugos teikimui.</li>
            <li>Konkreti saugojimo trukmė priklausys nuo duomenų tipo ir apdorojimo tikslo:
              <ul className="list-disc ml-6">
                <li>Naudojimosi Paslauga duomenys bus saugomi iki 2 metų.</li>
                <li>Asmeniniai ir finansiniai duomenys gali būti saugomi iki 10 metų, nebent teisės aktai numato kitus saugojimo terminus.</li>
              </ul>
            </li>
          </ul>
          <h2 className="text-lg font-semibold mt-6">5. ASMENS DUOMENŲ DALIJIMASIS SU TREČIOSIOS ŠALIMS</h2>
          <ul className="list-disc ml-6">
            <li>Jūsų asmens duomenys gali būti perduodami trečiosioms šalims šiais atvejais:
              <ul className="list-disc ml-6">
                <li>Paslaugų teikėjai – Bendradarbiaujame su trečiosiomis šalimis (pvz., debesų paslaugų teikėjais, mokėjimų paslaugų teikėjais), kurie apdoroja Jūsų duomenis mūsų vardu.</li>
                <li>Teisiniai reikalavimai – Jei įstatymai numato, kad turime perduoti Jūsų duomenis teisėsaugos institucijoms, teismams ar kitoms valdžios institucijoms.</li>
                <li>Kiti atvejai – Jūsų asmens duomenys gali būti perduodami su Jūsų sutikimu arba pagal sutartinius įsipareigojimus.</li>
              </ul>
            </li>
          </ul>
          <h2 className="text-lg font-semibold mt-6">6. JŪSŲ TEISĖS</h2>
          <ul className="list-disc ml-6">
            <li>Pagal BDAR, Jūs turite šias teises dėl savo asmens duomenų:
              <ul className="list-disc ml-6">
                <li>Teisė prieiti prie duomenų – Turite teisę gauti informaciją apie Jūsų asmens duomenų apdorojimą.</li>
                <li>Teisė taisyti duomenis – Jei Jūsų duomenys yra neteisingi ar pasenę, galite paprašyti juos ištaisyti.</li>
                <li>Teisė ištrinti duomenis – Turite teisę paprašyti ištrinti savo duomenis, jei jie nebereikalingi Paslaugos tikslams pasiekti.</li>
                <li>Teisė apriboti apdorojimą – Tam tikrais atvejais galite paprašyti apriboti savo duomenų apdorojimą.</li>
                <li>Teisė nesutikti su apdorojimu – Jei apdorojimas grindžiamas teisėtu interesu, galite nesutikti su tokiu apdorojimu.</li>
                <li>Teisė į duomenų perkeliamumą – Turite teisę gauti savo duomenis struktūruotu ir kompiuteriu skaitomu formatu.</li>
              </ul>
            </li>
          </ul>
          <p>Norėdami pasinaudoti šiomis teisėmis, susisiekite su mumis el. paštu: <a href="mailto:info@finhudas.lt" className="text-blue-600 underline">info@finhudas.lt</a>.</p>
          <h2 className="text-lg font-semibold mt-6">7. ASMENS DUOMENŲ APSAUGA</h2>
          <p>Mes imsimės tinkamų techninių ir organizacinių priemonių, kad užtikrintume Jūsų asmens duomenų saugumą ir apsaugą nuo neteisėto prieigos, naudojimo, atskleidimo, keitimo ir sunaikinimo. Tai apima, bet neapsiriboja, šifravimu, prieigos kontrolės priemonėmis ir saugumo audito procedūromis.</p>
          <h2 className="text-lg font-semibold mt-6">8. PRIVATUMO POLITIKOS PAKEITIMAI</h2>
          <p>Mes pasiliekame teisę periodiškai atnaujinti šią Privatumo politiką. Apie reikšmingus pakeitimus informuosime Jus per Paslaugą arba el. paštu.</p>
          <h2 className="text-lg font-semibold mt-6">9. SUSISIEKITE SU MUMIS</h2>
          <p>Jei turite klausimų dėl šios Privatumo politikos ar Jūsų asmens duomenų tvarkymo, prašome susisiekti su mumis el. paštu: <a href="mailto:info@finhudas.lt" className="text-blue-600 underline">info@finhudas.lt</a>.</p>
          <div className="text-xs text-gray-500 mt-8">
            © 2025 MB Kurohudas. Visos teisės saugomos. Paskutinės redakcijos data: 2025.01.21
          </div>
        </div>
      </div>
      <div className="mt-8">
        <ButtonLink to="/profile">
          Grįžti atgal
        </ButtonLink>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
